/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-styled */
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N0, N20, N300A, N400A, N800 } from '@atlaskit/theme/colors';

export const QuickCardContainer = styled.div<{
	isDisabled: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& button': {
		borderRadius: '3px',
		alignItems: 'center',
		padding: `${token('space.200', '16px')} ${token('space.150', '12px')}`,
	},
});

export const ButtonText = styled.div<{
	isDisabled: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) =>
		props.isDisabled ? token('color.text.disabled', N400A) : token('color.text.subtle', N800),
	font: token('font.body'),
	fontWeight: token('font.weight.regular', '500'),
});

export const QuickCardIcon = styled.div<{ isDisabled: boolean }>({
	width: '24px',
	height: '24px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	opacity: (props) => (props.isDisabled ? '0.4' : '1'),
});

export const QuickCardColumn = styled.div({
	flexDirection: 'column',
	display: 'flex',
});

export const BlankPageQuickActionsCardContainer = styled.div<{
	isTemplatesPanelOpen: boolean;
	shouldAdjustForContextPanel: boolean;
}>({
	flexDirection: 'column',
	display: 'flex',
	bottom: token('space.300', '24px'),
	padding: token('space.200', '16px'),
	border: `1px solid ${token('color.border', N20)}`,
	gap: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderRadius: token('space.100', '8px'),
	backgroundColor: token('elevation.surface', N0),
	zIndex: '2',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginRight: ({ isTemplatesPanelOpen, shouldAdjustForContextPanel }) =>
		isTemplatesPanelOpen && shouldAdjustForContextPanel ? '-320px' : '0px',
});

export const BlankPageQuickActionsWrapper = styled.div<{ isTemplatesPanelOpen: boolean }>({
	display: 'flex',
	width: 'auto',
	justifyContent: 'center',
	paddingBottom: token('space.250', '20px'),
	position: 'absolute',
	bottom: '0px',
	left: '0px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: ({ isTemplatesPanelOpen }) => (isTemplatesPanelOpen ? '320px' : '0px'),
	padding: token('space.200', '16px'),
	backgroundColor: token('elevation.surface', N0),
});

export const BlankPageQuickActionsTemplatePreviewWrapper = styled.div({
	display: 'flex',
	width: '100%',
	justifyContent: 'center',
	position: 'relative',
	backgroundColor: token('elevation.surface', N0),
});

export const Link = styled.div<{ isActive: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& button': {
		borderRadius: '3px',
		alignItems: 'center',
		padding: `${token('space.200', '16px')} ${token('space.150', '12px')}`,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& button:not(:hover)': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: ({ isActive }) =>
			isActive
				? `${token('color.background.neutral.subtle.pressed', N300A)} !important`
				: 'transparent !important',
	},
});

export const BlankPageQuickActionsTemplatePreviewContainer = styled.div<{
	shouldShowTemplatePreview: boolean;
	editorWidth: number;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	display: ({ shouldShowTemplatePreview }) => (shouldShowTemplatePreview ? 'auto' : 'none'),
	position: 'absolute',
	// As editor width shrinks, we need to have the overlay higher up to account
	// for the placeholder as it wraps. As the placeholder wraps to multiple lines,
	// the template preview overlay no longer covers it, removing the appearance of
	// an "in-editor" preview.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	top: ({ editorWidth }) => (editorWidth < 500 ? '-110px' : editorWidth < 820 ? '-80px' : '-60px'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingBottom: '120px',
	backgroundColor: token('elevation.surface', N0),
	width: '100%',
	zIndex: '1',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& *': {
		pointerEvents: 'none',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		height: 'auto',
		minHeight: token('space.500', '40px'),
		backgroundColor: token('elevation.surface', N0),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& [data-testid="template-preview-scroll-wrapper"]': {
		transform: 'unset',
		width: '100%',
		padding: '0px',
		backgroundColor: token('elevation.surface', N0),
		// this targets the wrapper around the renderer which is what sets its padding
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'& div:has(.ak-renderer-document)': {
			paddingLeft: '0px',
			paddingRight: '0px',
			marginLeft: '0px',
			marginRight: '0px',
			maxWidth: 'unset',
		},
	},
});
